<template>
	<div>
		<v-card class="mb-8">
			<v-card-title class="d-flex align-center">
				<v-icon
					icon="$email"
					start
				/>
				<translate>
					Email templates
				</translate>
				<v-spacer />
				<v-btn
					color="primary"
					variant="flat"
					prepend-icon="$plus"
					@click="goToCreate"
				>
					<translate>Create</translate>
				</v-btn>
			</v-card-title>
			<v-card-text>
				<v-row>
					<v-col
						cols="4"
					>
						<v-select
							v-if="methods"
							v-model="methodFilter"
							variant="outlined"
							:items="methods"
							:label="`${$gettext('Method')} ${$gettext('filter')}`"
							clearable
							hide-details
						/>
					</v-col>
					<v-col
						cols="4"
					>
						<v-select
							v-if="mediums"
							v-model="mediumFilter"
							variant="outlined"
							:items="mediums"
							:label="`${$gettext('Medium')} ${$gettext('filter')}`"
							clearable
							hide-details
						/>
					</v-col>
					<v-col
						cols="4"
					>
						<v-select
							v-if="purposes"
							v-model="purposeFilter"
							variant="outlined"
							:items="purposes"
							:label="`${$gettext('Purpose')} ${$gettext('filter')}`"
							clearable
							hide-details
						/>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-text-field
							v-model="search"
							append-inner-icon="$search"
							variant="outlined"
							:label="$gettext('Search')"
							single-line
							hide-details
						/>
					</v-col>
				</v-row>
				<v-row
					class="child-flex"
				>
					<v-col>
						<v-data-table
							:headers="headers"
							:search="search"
							:items="filterEmailTemplateTypes"
							:custom-filter="searchFilter"
							:items-length="filterEmailTemplateTypes.length"
							:items-per-page="-1"
						>
							<template #item.name="{ item }">
								<a :href="`/bo/emailtemplates/view?id=${item.id}`">
									{{ item.name }}
								</a>
							</template>
						</v-data-table>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
/**
 * Component for /bo/emailtemplates.
 */
import {
	axios,
} from '../../../../services/axios-service';
import {
	displayError,
} from 'laravel-front-library';

export default {
	name: 'EmailTemplatesTypesOverview',

	data () {
		return {
			search: '',
			methods: null,
			methodFilter: '',
			mediums: null,
			mediumFilter: '',
			purposes: null,
			purposeFilter: '',
			emailTemplateTypes: [],
		};
	},

	computed: {
		headers () {
			return [
				{
					title: 'id', align: 'start', sortable: true, value: 'id', filterable: false
				},
				{
					title: this.$gettext('Template Code'), sortable: true, value: 'name', filterable: true
				},
				{
					title: this.$gettext('Title'), sortable: true, value: 'title', filterable: true
				},
				{
					title: this.$gettext('Method'), sortable: true, value: 'method', filterable: false
				},
				{
					title: this.$gettext('Medium'), sortable: true, value: 'medium', filterable: false
				},
				{
					title: this.$gettext('Purpose'), sortable: true, value: 'purpose', filterable: false
				},
			];
		},

		filterEmailTemplateTypes () {
			return this.emailTemplateTypes.filter((templateType) => {
				return ((!this.methodFilter || templateType.method === this.methodFilter)	&&
					(!this.mediumFilter || templateType.medium === this.mediumFilter)	&&
					(!this.purposeFilter || templateType.purpose === this.purposeFilter));
			});
		}
	},

	created () {
		this.getEmailTemplateTypesData();
	},


	methods: {
		/**
		 * Sets location to the emailtemplate type creation route
		 *
		 * @returns {void}
		 */
		goToCreate () {
			window.location.href = '/bo/emailtemplates/createtype';
		},

		/**
		 * Get email template data and available filters for the table.
		 *
		 * @returns {void}
		 */
		getEmailTemplateTypesData () {
			axios.get('/bo/emailtemplates/emailtemplatetypesdata')
				.then(({
					data: data
				}) => {
					this.emailTemplateTypes = data.emailTemplateTypes;
					this.methods = data.methods;
					this.mediums = data.mediums;
					this.purposes = data.purposes;
				})
				.catch(() => {
					displayError(this.$gettext('Something has gone wrong during during data retrieval'));
				});
		},

		/**
		 * Checks if our language is a flag path or just text.
		 *
		 * @param {string} language - language the email template is.
		 * @returns {boolean} Whether it is a flag path or not
		 */
		ifFile (language) {
			return !!/(?:\.([^.]+))?$/.exec(language)[1];
		},

		/**
		 * Search on template name or title
		 *
		 * @param {object} value value
		 * @param {string} search user inputted search
		 * @param {object} item all order data
		 * @returns {boolean} in filter or out
		 */
		searchFilter (value, search, item) {
			return item.raw.name.toLowerCase().includes(search.toLowerCase()) || item.raw.title.toLowerCase().includes(search.toLowerCase());
		}
	}
};
</script>
